import { UseQueryOptions } from "react-query";

const stableOptions = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
} as const;

export function stableQueryOptions<T>(): Partial<UseQueryOptions<T>> {
    return { ...stableOptions };
}

export function stableQueryOptionsRpc() {
    return { ...stableOptions };
}
